export const CORRECTIONAL_JUDICIARY_PROCESS = 'Procédure correctionnelle';
export const MODIFIER = 'Modifier';
